module.exports = __webpack_public_path__ + "static/media/security.b460db6a.jpg";